const DesignerList = class extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.initMenuInteractions();
    }
  
    initMenuInteractions() {
      const designerMenuItems = this.querySelectorAll('.designer-main-menu a');
      const designerMenuContainer = this.querySelectorAll('.designer-container-child-link');
  
      designerMenuItems.forEach(item => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          const targetId = item.getAttribute('href').substring(1);
          const targetMenu = this.querySelector(`#${targetId}`);
          const isActive = item.classList.contains('active-opacity');
  
          designerMenuItems.forEach(link => {
            link.classList.remove('active-opacity');
          });
      
          designerMenuContainer.forEach(container => {
            container.classList.remove('item-selected');
          });
      
          this.querySelectorAll('.section-designer__menu-child-link').forEach(link => {
            link.classList.remove('selected');
          });
  
          if (!isActive) {
            item.classList.add('active-opacity');
            designerMenuContainer.forEach(container => {
              container.classList.add('item-selected');
            });
            targetMenu.classList.add('selected');
          } else {
            designerMenuContainer.forEach(container => {
              container.classList.remove('item-selected');
            });
            targetMenu.classList.remove('selected');
          }
        });
      });
    }
  }
  
  window.customElements.define('designer-list', DesignerList);